import { render, staticRenderFns } from "./ecenter-table-pagination.vue?vue&type=template&id=6f07cd3f&"
import script from "./ecenter-table-pagination.vue?vue&type=script&lang=js&"
export * from "./ecenter-table-pagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports